import { render, staticRenderFns } from "./InformationBoxEdit.vue?vue&type=template&id=57779d22&scoped=true&"
import script from "./InformationBoxEdit.vue?vue&type=script&lang=js&"
export * from "./InformationBoxEdit.vue?vue&type=script&lang=js&"
import style0 from "./InformationBoxEdit.vue?vue&type=style&index=0&id=57779d22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57779d22",
  null
  
)

export default component.exports